var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('FileUploadMulti', {
    attrs: {
      "instruction": _vm.instruction,
      "snackbarTitle": _vm.multiSteps.frontLeft.text,
      "example": _vm.multiSteps.frontLeft.example,
      "overlay": _vm.multiSteps.frontLeft.overlay,
      "text": _vm.multiSteps.frontLeft.text,
      "textAlt": _vm.multiSteps.frontLeft.textAlt,
      "filesCb": _vm.multiSteps.frontLeft.filesCb,
      "displayImages": _vm.getRegistrationImageFront,
      "handleDeleteCb": _vm.multiSteps.frontLeft.handleDelete,
      "handleUploadCb": _vm.multiSteps.frontLeft.handleUpload,
      "data-test-registration-front": ""
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }